module.exports = __webpack_public_path__ + "img/caso4.15d6dda6.jpeg";